import { z } from 'zod';
import { BootService } from '@/services/boot';
import { ServiceError } from '@/types/service';
import { Result } from '@/types/common';
import * as Type from '@/types/order';
import { requestHandler, responseHandler } from '@/utilities/service';

export async function getOrder(id: number): Promise<Result<ServiceError, Type.Order>> {
  return requestHandler(BootService.axios.get(`/orders/${id}`).then(responseHandler(Type.OrderSchema)));
}

export async function getOrderRefundDetail(id: number): Promise<Result<ServiceError, Type.OrderRefundDetail>> {
  return requestHandler(
    BootService.axios.get(`/orders/${id}/refund`).then(responseHandler(Type.OrderRefundDetailSchema)),
  );
}

export type CreateRefundData = {
  orderId: number;
  productId: number;
  authFeeIncluded: boolean;
  discountFeeIncluded: boolean;
  shippingFeeIncluded: boolean;
  dutyAndTaxFeeIncluded: boolean;
  type: number | string;
  comment: string;
  currency: string;
  amount: number;
};
export async function createOrderRefund(data: CreateRefundData): Promise<Result<ServiceError, unknown>> {
  return requestHandler(
    BootService.axios.post(`/products/${data.productId}/refund`, data).then(responseHandler(z.unknown())),
  );
}

export async function getOrderExtraRefundDetail(
  id: number,
): Promise<Result<ServiceError, Type.OrderExtraRefundDetail>> {
  return requestHandler(
    BootService.axios.get(`/orders/${id}/refund-extra`).then(responseHandler(Type.OrderExtraRefundDetailSchema)),
  );
}

export type CreateExtraRefundData = {
  type: number;
  reason: string;
  zendeskId: number;
  comment: string;
  currency: string;
  amount: number;
};
export async function createOrderExtraRefund(
  id: number,
  data: CreateExtraRefundData,
): Promise<Result<ServiceError, unknown>> {
  return requestHandler(BootService.axios.post(`/orders/${id}/refund-extra`, data).then(responseHandler(z.unknown())));
}

export async function getOrderInvoice(
  orderId: number,
  buyerId: number,
  isLitigation: boolean,
): Promise<Result<ServiceError, Type.OrderInvoice>> {
  return requestHandler(
    BootService.axios
      .get(`/orders/${orderId}/invoice?buyerId=${buyerId}&isLitigation=${isLitigation}`)
      .then(responseHandler(Type.OrderInvoiceSchema)),
  );
}

export async function removePickupDeliveryAddress(orderId: number): Promise<Result<ServiceError, unknown>> {
  return requestHandler(
    BootService.axios.delete(`/orders/${orderId}/delivery-option`).then(responseHandler(z.unknown())),
  );
}

export async function getChargeBack(orderId: string): Promise<Result<ServiceError, { data: Type.ChargeBack[] }>> {
  return requestHandler(
    BootService.axios
      .get(`/orders/${orderId}/chargeback`)
      .then(responseHandler(z.object({ data: Type.ChargeBackSchema.array() }))),
  );
}
